import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { Card } from "@/components/wpl/card/src/card";
import { wacToken } from "@/libraries/design/foundations";

import { JiraServiceManagementTemplateMessageMap } from "../../../../templates/software/jira/templates/service-management/jira-templates-page/src/content/templates-grid-content-intl";

import type { Template } from "../../../..//content/templates/template.types";

export interface TemplateCardProps {
    template: Template;
}

const colorN700 = "#253858";

const containerStyles = css({
    // Overriding default card styles to match JSM templates
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".text-section": {
        padding: "32px !important"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "h4": {
        color: `${colorN700} !important`,
        fontSize: "1.25rem !important",
        lineHeight: "1.2rem !important",
        marginBlockEnd: "16px !important"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "p": {
        color: `${colorN700} !important`,
        fontSize: "1rem !important",
        lineHeight: "1.5rem !important",
        marginBlockEnd: "0 !important"
    },
    "boxShadow": `1px 1px 6px ${wacToken("color.neutral.dark1100")}`,
    "transition": "box-shadow 0.2s ease-in",
    "&:hover": {
        boxShadow: `0 4px 12px ${colorN700}`
    },
    "&:focus": {
        borderColor: `${wacToken("color.extended.blue1000")} 2px`
    },
    "borderRadius": "3px !important",
    "overflow": "hidden",
    "tabindex": "0 !important"
});

export const TemplateCard = ({ template }: TemplateCardProps) => {
    const intl = useIntl();

    const url = template.urlSlug
        ? `/software/jira/templates/${template.urlSlug}`
        : "";

    const messages =
        // @ts-ignore
        JiraServiceManagementTemplateMessageMap[template.templateId];

    if (messages) {
        return (
            <a href={url ?? ""} css={containerStyles}>
                <Card
                    className="template-card"
                    data-testid="template-card"
                    headerText={intl.formatMessage(messages.name)}
                    headerType="h4"
                    bodyText={intl.formatMessage(messages.oneLinerHeadline)}
                    backgroundColor={wacToken("color.neutral.light100")}
                    textColor={colorN700}
                    clickableCardUrl={url ?? ""}
                    pictureProps={{
                        image: {
                            src: template.templateIcon?.url ?? "",
                            alt:
                                intl.formatMessage(messages.iconDescription) ??
                                ""
                        }
                    }}
                />
            </a>
        );
    }

    return null;
};
